/**
 * Slice 3 (ADR-004/007). Types for the DS-owned admin role-management contract
 * consumed by the back-office role page. Mirrors the digital-services `Role`
 * enum and the `POST /auth/roles` / `GET /auth/roles/:email` payloads.
 */
export type Role = "admin" | "super-admin";

export type RoleAction = "grant" | "revoke";

/** The shape returned by both the read and the grant/revoke DS endpoints. */
export interface RolesResponse {
  roles: Role[];
}

/** The ordered set of roles the back-office page lets ops manage. */
export const MANAGEABLE_ROLES: Role[] = ["admin", "super-admin"];
